import React, {useState} from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import {makeStyles} from '@material-ui/core/styles';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Zoom from '@material-ui/core/Zoom';
import recoverypad_logo from '../assets/recoverypad_logo.png'
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import termsCondition from '../termsCondition.pdf';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.primary.light,
        padding: '5vh 5vw',
        minHeight: '100vh',
        fontFamily: '"museo_sans300", Arial, Helvetica, sans-serif !important;',
        fontSize: "20px",
        fontWeight: 400
    }
    , appbar: {
        backgroundColor: theme.palette.primary.light,
    },
    logo: {
        margin: '1vh',
        maxWidth: '15vh',
    },
    toolbarTitle: {
        width: "100%",
        textAlign: 'center'
    },
    title: {
        width: "100%",
        height: "150px",
        textAlign: "center",
        verticalAlign: "middle",
        padding: "60px",
        color: theme.palette.primary.light,
        fontSize: "35px",
        backgroundColor: theme.palette.secondary.main,
    },
    footer: {
        textAlign: "center",
        color: theme.palette.primary.light,
        backgroundColor: theme.palette.secondary.main,
        width: "100%",
        margin: 'auto',
        fontSize: "15px",
        padding: '50px'
    },
    footerappbar: {
        textAlign: "center",
        padding: '50px',
        top: 'auto',
        bottom: 0,
        color: theme.palette.primary.light,
        backgroundColor: theme.palette.secondary.main,
    },
    zoom: {
        padding: 25
    },
    gridContainer: {},
}));

function ScrollTop(props: any) {
    const {children, window} = props;
    const classes = useStyles();
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
        disableHysteresis: true,
        threshold: 100,
    });

    const handleClick = (event: any) => {
        const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');

        if (anchor) {
            anchor.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    };

    return (
        <Zoom in={trigger}>
            <div onClick={handleClick} role="presentation" className={classes.zoom}>
                {children}
            </div>
        </Zoom>
    );
}

ScrollTop.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};

export default function BackToTop(props: any) {
    const classes = useStyles()
    const [numPages, setNumPages] = useState(null);

    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        setNumPages(nextNumPages);
    }
    return (
        <Container className={classes.root}>
            <Grid
                item
                xs={12}
                container
                className={classes.gridContainer}
                alignItems="center"
                direction="column"
            >

                <AppBar className={classes.appbar}>
                    <Toolbar>
                        <img src={recoverypad_logo} alt="logo" className={classes.logo}/>
                    </Toolbar>
                </AppBar>
                <Toolbar id="back-to-top-anchor"/>
                <Document
                    file={termsCondition}
                    loading={"Loading Terms and Condition"}
                    onLoadSuccess={onDocumentLoadSuccess}
                >
                    {
                        Array.from(
                            new Array(numPages),
                            (el, index) => (
                                <Page
                                    width={1100}
                                    className={classes.pagePrivacy}
                                    key={`page_${index + 1}`}
                                    pageNumber={index + 1}
                                />
                            ),
                        )
                    }
                </Document>
                <ScrollTop>
                    <Fab color="secondary" size="small" aria-label="scroll back to top">
                        <KeyboardArrowUpIcon/>
                    </Fab>
                </ScrollTop>
            </Grid>
        </Container>
    );
}